<template>
  <div>
    <div
      class="pn pn1"
      style="overflow:hidden"
    >
      <div class="pn-in">
        <div class="pn-bd">
          <div class="c1">
            <!--轮播图-->
            <div class="c1-l js-focus">
              <div class="focus-con">
                <swiper :options="swiperOption">
                  <swiper-slide
                    class="swiper-slide"
                    v-for="(item,index) in focusImgList"
                    :key="index"
                    style=" cursor:pointer "
                  >
                    <img :src="item.BannerImgUrl">
                  </swiper-slide>
                  <!-- 分页器 -->
                  <div
                    class="swiper-pagination"
                    slot="pagination"
                  />
                  <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
                  <!-- 左右箭头 -->
                  <!-- <div
                    class="swiper-button-prev"
                    slot="button-prev"
                  />
                  <div
                    class="swiper-button-next"
                    slot="button-next"
                  /> -->
                </swiper>
              </div>
            </div>
            <!--/轮播图-->
            <!--文章列表-->
            <div class="c1-r js-tab">
              <div class="c1-r-hd">
                <div class="tab">
                  <a
                    href="javascript:;"
                    @click="currentNewsItem = 0"
                    :class="currentNewsItem===0?'current':''"
                  >最新</a>
                  <a
                    href="javascript:;"
                    @click="currentNewsItem = 1"
                    :class="currentNewsItem===1?'current':''"
                  >新闻</a>
                  <a
                    href="javascript:;"
                    @click="currentNewsItem = 2"
                    :class="currentNewsItem===2?'current':''"
                  >公告</a>
                  <a
                    href="javascript:;"
                    @click="currentNewsItem = 3"
                    :class="currentNewsItem===3?'current':''"
                  >活动</a>
                </div>
                <router-link
                  class="more"
                  to="/news/list"
                >
                  更多
                </router-link>
              </div>
              <div class="c1-r-bd tab-pn">
                <div
                  class="tab-pn-item"
                  v-show="currentNewsItem === 0"
                >
                  <router-link
                    class="tit"
                    :to="{path:'news/view',query:{id:topNews[0]?topNews[0].id:0,tid:0}}"
                  >
                    {{ topNews[0]&&topNews[0].id>0?topNews[0].title:'' }}
                  </router-link>
                  <ul
                    class="txt-list"
                  >
                    <li
                      class="item"
                      v-for="(item,index) in indexNews0"
                      :key="index"
                    >
                      <span class="tag">{{ getNewsTypeShortName(item.typeID) }}：</span>
                      <div class="txt">
                        <router-link
                          class="con"
                          :to="{path:'news/view',query:{id:item.id}}"
                        >
                          {{ item.title }}
                        </router-link>
                      </div>
                      <span class="date">{{ item.createTime | dateformat('MM/DD') }}</span>
                    </li>
                  </ul>
                </div>
                <div
                  class="tab-pn-item"
                  v-show="currentNewsItem === 1"
                >
                  <router-link
                    class="tit"
                    :to="{path:'news/view',query:{id:topNews[1]?topNews[1].id:0,tid:1}}"
                  >
                    {{ topNews[1]&&topNews[1].id>0?topNews[1].title:'' }}
                  </router-link>
                  <ul
                    class="txt-list"
                  >
                    <li
                      class="item"
                      v-for="(item,index) in indexNews1"
                      :key="index"
                    >
                      <span class="tag">{{ getNewsTypeShortName(item.typeID) }}：</span>
                      <div class="txt">
                        <router-link
                          class="con"
                          :to="{path:'news/view',query:{id:item.id}}"
                        >
                          {{ item.title }}
                        </router-link>
                      </div>
                      <span class="date">{{ item.createTime | dateformat('MM/DD') }}</span>
                    </li>
                  </ul>
                </div>
                <div
                  class="tab-pn-item"
                  v-show="currentNewsItem === 2"
                >
                  <router-link
                    class="tit"
                    :to="{path:'news/view',query:{id:topNews[2]?topNews[2].id:0,tid:2}}"
                  >
                    {{ topNews[2]&&topNews[2].id>0?topNews[2].title:'' }}
                  </router-link>
                  <ul
                    class="txt-list"
                  >
                    <li
                      class="item"
                      v-for="(item,index) in indexNews2"
                      :key="index"
                    >
                      <span class="tag">{{ getNewsTypeShortName(item.typeID) }}：</span>
                      <div class="txt">
                        <router-link
                          class="con"
                          :to="{path:'news/view',query:{id:item.id}}"
                        >
                          {{ item.title }}
                        </router-link>
                      </div>
                      <span class="date">{{ item.createTime | dateformat('MM/DD') }}</span>
                    </li>
                  </ul>
                </div>
                <div
                  class="tab-pn-item"
                  v-show="currentNewsItem === 3"
                >
                  <router-link
                    class="tit"
                    :to="{path:'news/view',query:{id:topNews[3]?topNews[3].id:0,tid:3}}"
                  >
                    {{ topNews[3]&&topNews[3].id>0?topNews[3].title:'' }}
                  </router-link>
                  <ul
                    class="txt-list"
                  >
                    <li
                      class="item"
                      v-for="(item,index) in indexNews3"
                      :key="index"
                    >
                      <span class="tag">{{ getNewsTypeShortName(item.typeID) }}：</span>
                      <div class="txt">
                        <router-link
                          class="con"
                          :to="{path:'news/view',query:{id:item.id}}"
                        >
                          {{ item.title }}
                        </router-link>
                      </div>
                      <span class="date">{{ item.createTime | dateformat('MM/DD') }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--/文章列表-->
          </div>
          <!-- <div class="c2">
            <a
              class="entrance"
              href="/#/intro/view?id=44&tid=5"
            >
              <img
                src="../../assets/images/img1.png"
              >
              <span />
            </a>
            <a
              class="entrance"
              href="/#/intro/view?id=45&tid=5"
            >
              <img
                src="../../assets/images/img2.png"
              >
              <span />
            </a>
            <a
              class="entrance"
              href="/#/intro/view?id=47&tid=5"
            >
              <img
                src="../../assets/images/img3.png"
              >
              <span />
            </a>
            <a
              class="entrance"
              href="/#/intro/view?id=46&tid=5"
            >
              <img
                src="../../assets/images/img4.png"
              >
              <span />
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNewsTypeShortName } from '../../utils/utils'

let vm = null

export default {
  data () {
    return {
      focusImgList: [],
      currentNewsItem: 0,
      swiperOption: {
        // 显示分页
        pagination: {
          el: '.swiper-pagination'
        },
        // scrollbar: '.swiper-scrollbar',
        // 设置点击箭头
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // 自动轮播
        autoplay: {
          delay: 2000, // 秒
          disableOnInteraction: false// 滑动不会失效
        },
        // 开启循环模式
        loop: true,
        slidesPreView: 1,
        spaceBetween: 30,
        on: {
          click: function () {
            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
            // console.log(this); // -> Swiper
            // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
            const realIndex = this.realIndex
            // console.log(realIndex)
            // console.log(vm.focusImgList[realIndex])
            // vm.GoToNewsContent(vm.focusImgList[realIndex].newsID)
            location.href = vm.focusImgList[realIndex].Url
          }
        }
      },
      topNews: [],
      indexNews0: [],
      indexNews1: [],
      indexNews2: [],
      indexNews3: []
    }
  },
  created () {
    vm = this
    this.getBanner()
    this.getTopNews()
    this.getIndexNews()
  },
  methods:
  {
    getBanner () {
      this.$api.getBannerList()
        .then((res) => {
          this.focusImgList = res.data
          // console.log(this.focusImgList)
        })
    },
    getTopNews () {
      this.$api.getTopNewsList()
        .then((res) => {
          this.topNews = res.data.list
          // console.log(this.topNews)
        })
    },
    getIndexNews () {
      this.$api.getIndexNewsList()
        .then((res) => {
          this.indexNews0 = res.data.list0
          this.indexNews1 = res.data.list1
          this.indexNews2 = res.data.list2
          this.indexNews3 = res.data.list3
        })
    },
    GoToNewsContent (newsID) {
      const routeData = this.$router.resolve({ path: '/news/view', query: { id: newsID } })
      window.open(routeData.href, '_blank')
    },
    getNewsTypeShortName
  }
}
</script>
<style scoped>
.wrapper-index .pn1 .c1-l .focus-con {
    height:auto
}
.wrapper-index .pn1 .c2 .entrance span {
    position: absolute;
    left: 40px;
    top: 185px;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/line1.vue